import ObjectScreen from './ObjectScreen';

export default ObjectScreen;
